import type { Config } from '@grandvisionhq/shipping'

export const getDeliveryIndicatorConfig = (): Config => ({
  inventoryChannels: {
    '46d11120-b7df-435f-a9bf-35dd232935fa': {
      // online-store TEST
      expectedDeliveryDays: {
        onStock: '1-3',
        outOfStock: '8-10',
      },
    },
    '2f1f38a2-be8a-449a-b69b-9c77b1dc39c4': {
      // online-store ACCT
      expectedDeliveryDays: {
        onStock: '1-3',
        outOfStock: '8-10',
      },
    },
    '543f4693-871e-4a42-9540-9217b9a6bfa4': {
      // online-store PROD
      expectedDeliveryDays: {
        onStock: '1-3',
        outOfStock: '8-10',
      },
    },
  },
  missingInventoryChannelStrategy: {
    expectedDeliveryDays: '8+',
  },
  nextDayDeliveryTimeLimit: '18:00',
  productTypeDeliveryConfig: [
    {
      type: 'GLASSES_BUNDLE',
      expectedDeliveryDays: '7-10',
    },
    {
      type: 'NON_PRESCRIPTION_BUNDLE',
      expectedDeliveryDays: '5',
    },
    {
      type: 'CONTACT_LENSES',
      expectedDeliveryDays: '3',
    },
    {
      type: 'REGULAR',
      expectedDeliveryDays: '1',
    },
  ],
})
